// Values match the suffix of the Experiment.Precision.* / Experiment.SignificantDigits.* system properties
export enum EPrecisionType {
  Concentration = 'Concentration',
  Volume = 'Volume',
  PH = 'pH',
}

export type PrecisionSetting = { significantDigits: number; precision: number };

export type PrecisionFormatter = (value: number, type: EPrecisionType) => string;

//Significant digits and Precision Values taken from V3, used until system properties are loaded
export const defaultPrecisionSettings: Record<EPrecisionType, PrecisionSetting> = {
  [EPrecisionType.Concentration]: { significantDigits: 5, precision: 3 },
  [EPrecisionType.Volume]: { significantDigits: 5, precision: 3 },
  [EPrecisionType.PH]: { significantDigits: 2, precision: 2 },
};

export const getPrecisionPropertyNames = (type: EPrecisionType) => ({
  significantDigits: `Experiment.SignificantDigits.${type}`,
  precision: `Experiment.Precision.${type}`,
});

const getZeros = (zeroCount: number): string => {
  if (zeroCount < 0) {
    zeroCount = Math.abs(zeroCount);
  }
  return '0'.repeat(zeroCount);
};
export const applyPrecision = (
  value: number,
  significantDigits: number,
  precision: number,
): string => {
  if (value == null) {
    return '';
  }
  const numString = value.toString();
  let numberOfDecimalDigits;
  const integerPart: string = numString.split('.')[0];

  if (integerPart.length >= significantDigits) {
    return integerPart;
  }

  if (integerPart === '0') {
    numberOfDecimalDigits = significantDigits;
  } else {
    numberOfDecimalDigits = significantDigits - integerPart.length;
  }

  if (numberOfDecimalDigits > precision) {
    // Small non-zero values keep extra decimals so they don't round down to zero
    if (value === 0 || value >= parseFloat(`0.${getZeros(precision - 1)}1`)) {
      numberOfDecimalDigits = precision;
    }
  }
  return value.toFixed(numberOfDecimalDigits);
};
